// src/data/claimRequirements.js - the CODE over the claim requirements tables (ruling 321 slice 3c, task list section 735).
// CLAIM_REQUIREMENTS and AGREEMENT_NAME_ALIASES are installation content: installations\smart-td\content\claimRequirementsTable.js,
// projected to src\data\claimRequirementsTable.js, and re-exported here so no importer changed. What this build does with a
// name - resolve it, say whether anything is recorded, and say so plainly when nothing is - is the platform's, not a union's.
import { CLAIM_REQUIREMENTS, AGREEMENT_NAME_ALIASES } from './claimRequirementsTable';
export { CLAIM_REQUIREMENTS, AGREEMENT_NAME_ALIASES };

// The canonical key for a name as a claim carries it, or '' when this build holds no requirements
// for it. Exported so the verifier can walk every name AGREEMENT_LOOKUP emits.
export function canonicalAgreementKey(agreementName) {
  const n = String(agreementName || '').trim();
  if (!n) return '';
  if (CLAIM_REQUIREMENTS[n]) return n;
  const aliased = AGREEMENT_NAME_ALIASES[n];
  if (aliased && CLAIM_REQUIREMENTS[aliased]) return aliased;
  return '';
}

// 'recorded' | 'not_recorded'. THE POINT OF THIS FUNCTION IS THAT A SCREEN CAN TELL THE DIFFERENCE
// between "this agreement imposes nothing" and "this platform holds nothing for this agreement".
// They look identical from a null return, and only one of them is safe to show as a blank.
export function requirementsState(agreementName) {
  return canonicalAgreementKey(agreementName) ? 'recorded' : 'not_recorded';
}

// What a member or officer is told when the requirements are not recorded. It states the absence and
// routes him to the person who actually knows, and it does NOT guess at a number of days.
export const NO_REQUIREMENTS_TEXT =
  'No filing requirements or time limit are recorded on this platform for this agreement. That does '
  + 'not mean there is none - it means this platform does not hold it. Your time limit is in your '
  + 'controlling agreement, and your General Chairperson holds authority over it. Do not treat the '
  + 'absence of a date here as extra time.';

// Agreements whose claims rule is not yet catalogued resolve to null ->
// the Requirements panel renders NOTHING (Bob, 2026-08-04: "if nothing, then nothing").
export function getClaimRequirements(agreementName) {
  const key = canonicalAgreementKey(agreementName);
  return key ? CLAIM_REQUIREMENTS[key] : null;
}
